import { capitalize, has } from 'lodash';
import React from 'react';
import { Table } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../content/utils.js';
import { INITIATIVE_TYPES } from '../../../lib/schema.js';
import SubHeader from '../../SubHeader.jsx';
import InitiativeParticipationsTableRow from './InitiativeParticipationsTableRow.jsx';

const InitiativeParticipationsTable = ({
  initiativeParticipations,
  initiativeType,
}) => {
  const initiativeTypeCapitalized =
    initiativeType === INITIATIVE_TYPES[1]
      ? `${capitalize(initiativeType)}es`
      : `${capitalize(initiativeType)}s`;

  if (initiativeParticipations.length === 0) {
    return (
      <SubHeader bgWhite>
        <p className="text-muted m-0">
          {`Employee doesn’t have participation in ${initiativeTypeCapitalized} yet.`}
        </p>
      </SubHeader>
    );
  }

  const enabledColumns = {
    completion:
      has(initiativeParticipations[0], 'initiative.completionTracked') &&
      initiativeParticipations[0].initiative.completionTracked,
    mandatory: has(initiativeParticipations[0], 'initiative.mandatory'),
  };

  return (
    <Table hover style={{ tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th width="18%">Title</th>
          <th>{getOrgTermsContent('project')}</th>
          <th>Category</th>
          {/* {enabledColumns.completion && <th>Completion</th>} */}
          {/* {enabledColumns.mandatory && <th>Mandatory</th>} */}
          <th>Completion</th>
          <th>Mandatory</th>
          <th>Feedback Form</th>
          <th>Lead</th>
          <th>Date</th>
          <th width="135px" className="text-right">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        {initiativeParticipations.map((initiativeParticipation) => (
          <InitiativeParticipationsTableRow
            key={initiativeParticipation.id}
            initiativeParticipation={initiativeParticipation}
            showCompletion={enabledColumns.completion}
            showMandatory={enabledColumns.mandatory}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default InitiativeParticipationsTable;
